import type { AutoArea } from '~/lib/types';
import type { PhotoLayoutProps } from './Steps/Photos';

export const photoLayoutConfig: Record<AutoArea, PhotoLayoutProps> = {
  backDriversideAngle: {
    stepName: 'backDriversideAngle',
    documentDamage: true,
    subtitle: 'vsga:damagePhoto.subtitleBackDriversideAngle',
    bodyBold: 'vsga:damagePhoto.bodyBold',
    body1: 'vsga:damagePhoto.bodyBackDriversideAngle',
    illustration: '',
    cameraButtonText: 'vsga:general.nextButtonPhoto',
  },
  backPassengersideAngle: {
    stepName: 'backPassengersideAngle',
    documentDamage: true,
    subtitle: 'vsga:damagePhoto.subtitleBackPassengersideAngle',
    bodyBold: 'vsga:damagePhoto.bodyBold',
    body1: 'vsga:damagePhoto.bodyBackPassengersideAngle',
    illustration: '',
    cameraButtonText: 'vsga:general.nextButtonPhoto',
  },
  driverside: {
    stepName: 'driverside',
    documentDamage: true,
    subtitle: 'vsga:damagePhoto.subtitleDriverSide',
    bodyBold: 'vsga:damagePhoto.bodyBold',
    body1: 'vsga:damagePhoto.bodyDriverSide',
    illustration: '/images/vsga/picto-auto-links.svg',
    cameraButtonText: 'vsga:general.nextButtonPhoto',
    tipTranslationKey: 'vsga:tips.horizontalPhoto',
  },
  front: {
    stepName: 'front',
    documentDamage: true,
    subtitle: 'vsga:damagePhoto.subtitleFront',
    bodyBold: 'vsga:damagePhoto.bodyBold',
    body1: 'vsga:damagePhoto.bodyFront',
    illustration: '/images/vsga/picto-auto-vorne.svg',
    cameraButtonText: 'vsga:general.nextButtonPhoto',
  },
  frontDriversideAngle: {
    stepName: 'frontDriversideAngle',
    documentDamage: true,
    subtitle: 'vsga:damagePhoto.subtitleFrontDriversideAngle',
    bodyBold: 'vsga:damagePhoto.bodyBold',
    body1: 'vsga:damagePhoto.bodyFrontDriversideAngle',
    illustration: '',
    cameraButtonText: 'vsga:general.nextButtonPhoto',
  },
  frontPassengersideAngle: {
    stepName: 'frontPassengersideAngle',
    documentDamage: true,
    subtitle: 'vsga:damagePhoto.subtitleFrontPassengersideAngle',
    bodyBold: 'vsga:damagePhoto.bodyBold',
    body1: 'vsga:damagePhoto.bodyFrontPassengersideAngle',
    illustration: '',
    cameraButtonText: 'vsga:general.nextButtonPhoto',
  },
  passengerside: {
    stepName: 'passengerside',
    documentDamage: true,
    subtitle: 'vsga:damagePhoto.subtitlePassengerSide',
    bodyBold: 'vsga:damagePhoto.bodyBold',
    body1: 'vsga:damagePhoto.bodyPassengerSide',
    illustration: '/images/vsga/picto-auto-rechts.svg',
    cameraButtonText: 'vsga:general.nextButtonPhoto',
    tipTranslationKey: 'vsga:tips.horizontalPhoto',
  },
  rear: {
    stepName: 'rear',
    documentDamage: true,
    subtitle: 'vsga:damagePhoto.subtitleRear',
    bodyBold: 'vsga:damagePhoto.bodyBold',
    body1: 'vsga:damagePhoto.bodyRear',
    illustration: '/images/vsga/picto-auto-hinten.svg',
    cameraButtonText: 'vsga:general.nextButtonPhoto',
  },
  roofLeft: {
    stepName: 'roofLeft',
    documentDamage: true,
    subtitle: 'vsga:damagePhoto.subtitleRoofLeft',
    bodyBold: 'vsga:damagePhoto.bodyBold',
    body1: 'vsga:damagePhoto.bodyRoofLeft',
    illustration: '',
    cameraButtonText: 'vsga:general.nextButtonPhoto',
    tipTranslationKey: 'vsga:tips.roofImageCombinedTip',
  },
  roofRight: {
    stepName: 'roofRight',
    documentDamage: true,
    subtitle: 'vsga:damagePhoto.subtitleRoofRight',
    bodyBold: 'vsga:damagePhoto.bodyBold',
    body1: 'vsga:damagePhoto.bodyRoofRight',
    illustration: '',
    cameraButtonText: 'vsga:general.nextButtonPhoto',
    tipTranslationKey: 'vsga:tips.roofImageCombinedTip',
  },
  windshield: {
    stepName: 'windshield',
    documentDamage: true,
    subtitle: 'vsga:damagePhoto.subtitleWindshield',
    bodyBold: 'vsga:damagePhoto.bodyBold',
    body1: 'vsga:damagePhoto.bodyWindshield',
    illustration: '/images/vsga/picto-auto-Scheibe-Dach.svg',
    cameraButtonText: 'vsga:general.nextButtonPhoto',
  },
};
